
import { API_BASE_URL } from '../../config'
import axios from 'axios';

export const promise = (id) => {
    return (dispatch) => {
        return new Promise((resolve) => {
            dispatch({ type: "GET_ALL_JOBS", payload: "idfyhi" })
            resolve("fgkdfgh");
        });
    };
}


export const CommonApiFun = (uri, data) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            try {
                await fetch(API_BASE_URL + uri, {
                    method: 'POST',
                    body: data
                }).then((res) => res.json()).then((response) => {
                    resolve(response)
                })
            } catch (error) {
                reject(error)
            }
        });
    };
}

